import { css } from '@emotion/react';
import Tooltip from '@tippyjs/react';
import { FC } from 'react';

import { useTranslations } from '~src/commons/utils/translations/translate';

import { Icon } from '../icon';

interface InputInfoIconShellProps {
  message?: string;
  id?: string;
}

export const InputInfoIconShell: FC<InputInfoIconShellProps> = ({ message, id }) => {
  const { tICU } = useTranslations();
  return (
    <div css={styles.iconStyles}>
      {id && (
        <span id={id} css={styles.hiddenText}>
          {message}
        </span>
      )}

      <Tooltip content={<span>{message}</span>} trigger="mouseenter focus click">
        <button
          type="button"
          css={styles.helpButton}
          aria-label={tICU('widget.aria.TOOLTIP')}
          tabIndex={0}
        >
          <Icon type="questionmark" />
        </button>
      </Tooltip>
    </div>
  );
};

const styles = {
  iconStyles: css({
    padding: 0,
    background: 'none',
    border: 'none',
    position: 'relative',
  }),
  helpButton: css({
    padding: 0,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),
  hiddenText: css({
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: 0,
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    borderWidth: 0,
  }),
};
